<app-subnav [items]="subnav" ></app-subnav>
<div class="container my-5">
  <app-filter [categories]="categories" [(query)]="query" (queryChange)="updateFilter()"></app-filter>

  <!-- "Table" Header - nur ab md sichtbar -->
  <div class="row font-weight-bold py-2 border-bottom d-none d-md-flex">
    <div class="col-md-1">ID</div>
    <div class="col-md-3">Name</div>
    <div class="col-md-3">E-Mail</div>
    <div class="col-md-2">Kinder</div>
    <div class="col-md-3"></div>
  </div>

  <ng-container *ngFor="let et of eltern">
    <!-- Eltern Row -->
    <div class="row align-items-center py-3 border-bottom text-center text-md-left">
      <div class="col-12 col-md-1"><span class="d-md-none font-weight-bold">ID: </span>{{et.id}}</div>
      <div class="col-12 col-md-3 font-weight-bold font-weight-md-normal">{{et.vorname}} {{et.nachname}}</div>
      <div class="col-12 col-md-3 text-md-body">{{et.mail}}</div>
      <div class="col-12 col-md-2"><span class="d-md-none font-weight-bold">Kinder: </span>{{et.kinder.length}}</div>
      <div class="col-12 col-md-3 text-md-right mt-2 mt-md-0">
        <a class="btn pcButton mx-1" [routerLink]="'/kind/new/'+et.id" ngbTooltip="Kind hinzufügen"><i class="fas fa-plus"></i></a>
        <a class="btn pcButton mx-1" [routerLink]="'/eltern/edit/'+et.id" ngbTooltip="Account bearbeiten"><i class="fas fa-edit"></i></a>
        <button class="btn pcButton mx-1" ngbTooltip="Account löschen" (click)="deleteEltern(et)">
          <i [class]="'fas ' + (et.id === deleteElternActiveId ? 'fa-circle-notch fa-spin' : 'fa-trash')"></i>
        </button>
      </div>
    </div>

    <!-- Kinder Rows -->
    <ng-container *ngFor="let kd of et.kinder">
      <div class="row secondaryBgColor align-items-center py-2 border-bottom text-center text-md-left">
        <!-- Einrückung oder Marker für Kinder in der Desktop-Ansicht -->
        <div class="col-12 col-md-1 text-md-right small"><span class="d-md-none font-weight-bold">Kind ID: </span>{{kd.id}}</div>
        <div class="col-12 col-md-3 pl-md-4">{{kd.vorname}} {{kd.nachname}}</div>
        <div class="col-12 col-md-5">{{kd.geburtsdatum | ageFilter}} Jahre alt</div>
        <div class="col-12 col-md-3 text-md-right mt-2 mt-md-0">
          <a class="btn mx-1 pcButton" [routerLink]="'/kind/edit/'+kd.id" ngbTooltip="Kind bearbeiten"><i class="fas fa-edit"></i></a>
          <button class="btn pcButton mx-1" ngbTooltip="Kind löschen" (click)="deleteKind(kd)">
            <i [class]="'fas ' + (kd.id === deleteKindActiveId ? 'fa-circle-notch fa-spin' : 'fa-trash')"></i>
          </button>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
